import config from "@lib/config";

// Password reset functions (no auth required)
export async function requestPasswordReset(email) {
  const res = await fetch(`${config.apiBaseUrl}/api/password/forgot`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      email,
      domain: {
        key: "floats", // tell the api this is a floats password reset. This is used in place of the VerifyDomain middleware
      },
    }),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "Password reset request failed");
  }

  return data;
}

export async function resetPassword(
  token,
  email,
  password,
  passwordConfirmation
) {
  const res = await fetch(`${config.apiBaseUrl}/api/password/reset`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      token,
      email,
      password,
      password_confirmation: passwordConfirmation,
    }),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "Password reset failed");
  }

  return data;
}
